import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

type FieldErrorProps = {
    message?: string;
    id?: string;
    className?: string;
};

/**
 * Inline field validation error with an icon and animated reveal.
 * Rendered only when `message` is non-empty.
 * The parent input should reference this via `aria-describedby={id}`.
 */
export function FieldError({ message, id, className }: FieldErrorProps) {
    if (!message) return null;
    return (
        <p
            id={id}
            role="alert"
            data-testid="field-error"
            className={cn(
                "mt-1.5 flex items-start gap-1.5 text-xs font-medium text-error animate-fade-in",
                className,
            )}
        >
            <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
            <span>{message}</span>
        </p>
    );
}

export default FieldError;
